<template>
    <section class="c-section-grid-cars" id="haut-de-page" :class="{'-grid-cars-sidebar-active': $root.sidebarActive}">
        <Controls />
        <div class="o-container -full">
            <div class="c-grid-cars__wrap">
                <Sidebar :filters="$root.filters" />
                <div class="c-grid-cars">
                    <Card v-for="(car, i) in $root.items" type="small" :key="car.id" :car="car" :i="i" />
                    <Card v-if="$root.featured" type="big" :car="$root.featured" :i="33" />
                </div>
            </div>
            <Pager />
            <div class="u-text-center c-grid-cars-back-to-top">
                <a href="#haut-de-page">Retour <svgIco icon="arrow-up" /></a>
            </div>
        </div>
    </section>
    
</template>
<script>

export default {
    name: 'Listing',
    
    data() {
        return {
           
        }
    },
    computed: {
        
    },
    methods: {
        
    }
}
</script>